import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import { getYear } from "date-fns";

import {
  Container,
  ContainerCertificate,
  DownloadButton,
} from "./styles";

import ContentBox from "../../components/UI/ContentBox";
import Banner from "../../components/UI/Banner";
import Footer from "../../components/UI/Footer";
import Menu from "../../components/UI/Menu";
import ReadMoreButton from "../../components/UI/ReadMoreButton"
import FullScreenLoading from "../../components/UI/FullScreenLoading";

import useApi from "../../hooks/useApi";

import Certificate2024 from "./Template/Certificate2024";
import Certificate2025 from "./Template/Certificate2025";
import Certificate2026 from "./Template/Certificate2026";
import CertificatePalestra2026 from "./Template/CertificatePalestra2026";

import {icons} from "../../constants"

const CoursesCertificatePrint = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [certificate, setCertificate]= useState({
    idCertificate: "",
		idUserCertificate: "",
		courseTitle: "",
		name: "",
		cpf: "",
		totalWorkload: 0,
		hoursTaken: 0,
		hoursJustified: 0,
		courseBegin: new Date(),
		courseEnd: new Date(),
		createdAt: new Date(),
		updatedAt: "",
		canceled: null,
		reasonForCancellation: null,
		createdBy: "",
    additionalInformation: "",
  });

  const [isMobile, setIsMobile]= useState(false);

  const [getCertificate, certificateInfo] = useApi({
    debounceDelay: 1000,
    url: "canalPedagogico/course/certificate",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        let certificate = response.data.find((value)=>{return value.canceled===false});
        if(certificate){
          console.log("certificado", certificate);
          setCertificate(certificate);
        }
      }
    },
  });

  useEffect(() => {
    getCertificate({params:{id}});
    setIsMobile(window.innerWidth<=600);
    // eslint-disable-next-line
  }, []);

  return (
    <Container>
      <Menu />
      {(certificateInfo.loading) && <FullScreenLoading />}
      <Banner>
        Certificado
      </Banner>
      <ContentBox>
        {certificate.idCertificate!==""?
          <>
            {!isMobile && <ContainerCertificate>
              {getYear(new Date(certificate.createdAt))<=2024 && <PDFViewer width="100%" height="100%">
                <Certificate2024 certificate={certificate}/>
              </PDFViewer>}
              {getYear(new Date(certificate.createdAt))===2025 && <PDFViewer width="100%" height="100%">
                <Certificate2025 certificate={certificate}/>
              </PDFViewer>}
              {getYear(new Date(certificate.createdAt))===2026 && <PDFViewer width="100%" height="100%">
                {certificate.courseType === "5defe108-e450-413f-b518-74f17bcf14bd"?
                  <CertificatePalestra2026 certificate={certificate}/>:
                  <Certificate2026 certificate={certificate}/>}
              </PDFViewer>}
            </ContainerCertificate>}
            {isMobile && <>
              {getYear(new Date(certificate.createdAt))<=2024 && 
                <PDFDownloadLink document={<Certificate2024 certificate={certificate}/>} fileName={`${certificate.courseTitle.trim()}.pdf`}>
                  {({loading}) =>
                    loading ? <DownloadButton>Loading document...</DownloadButton> : <DownloadButton><img src={icons.btn_download} alt="download"/></DownloadButton>
                  }
                </PDFDownloadLink>}
              {getYear(new Date(certificate.createdAt))===2025 && 
                <PDFDownloadLink document={<Certificate2025 certificate={certificate}/>} fileName={`${certificate.courseTitle.trim()}.pdf`}>
                  {({loading}) =>
                    loading ? <DownloadButton>Loading document...</DownloadButton> : <DownloadButton><img src={icons.btn_download} alt="download"/></DownloadButton>
                  }
                </PDFDownloadLink>}
              {getYear(new Date(certificate.createdAt))===2026 &&
                <PDFDownloadLink document={
                  certificate.courseType === "5defe108-e450-413f-b518-74f17bcf14bd"?
                    <CertificatePalestra2026 certificate={certificate}/>:
                    <Certificate2026 certificate={certificate}/>
                  } fileName={`${certificate.courseTitle.trim()}.pdf`}>
                  {({loading}) =>
                    loading ? <DownloadButton>Loading document...</DownloadButton> : <DownloadButton><img src={icons.btn_download} alt="download"/></DownloadButton>
                  }
                </PDFDownloadLink>}
            </>}
          </>       
        :
        <>Certificado não localizado<br/></>
        }
        <ReadMoreButton text={"voltar"} onClick={()=>{navigate(-1);}}/>
      </ContentBox>

      <Footer />
    </Container>
  );
};

export default CoursesCertificatePrint;
